import Phaser from 'phaser'

/**
 * BootScene - First scene that runs
 * Handles initial setup and loading of essential assets
 * needed for the preloader (like loading bar graphics)
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' })
  }

  preload(): void {
    // Load minimal assets needed for the preload screen
    // In a real game, you'd load your loading bar graphics here
  }

  create(): void {
    // Set up any global game settings
    this.scale.on('resize', this.handleResize, this)

    // Proceed to preload scene
    this.scene.start('PreloadScene')
  }

  private handleResize(gameSize: Phaser.Structs.Size): void {
    // Handle resize events if needed
    console.log(`Game resized to: ${gameSize.width}x${gameSize.height}`)
  }
}
